import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ScrollToTop from "../utils/scrollTop";
function Contact() {
  const navigate = useNavigate();
  return (
    <>
    <ScrollToTop/>
    {/* <TopBar/> */}
    <div>
      <br />
      <br />
      <p className="head">CONTACT US</p>
      <div className="intro">
       <p>Do you need help? Get in touch with us now:</p>
       <p><b>Email :</b> contact.us@risetv.co.uk</p>
       <p><b>Phone number :</b> 626-315-1219</p>
      </div>
    </div>
    <Button variant={'contained'} onClick={()=>navigate(-1)}>Go back</Button>
    </>
  );
}

export default Contact;